import HomesGlobeIconAuth from "@/assets/brand/HomesGlobeIconAuth";
import { getConfig } from "@/get-config";

const BrnadInfoAuth = ({ title, subTitle1, subTitle2, showwImage = true }) => {
  const { cdnAssetUrl } = getConfig();

  return (
    <div className="h-full bg-secondary w-full rounded-lg py-8 ltr:pl-8 rtl:pr-8 relative sign-up-modal overflow-hidden">
      <HomesGlobeIconAuth />
      <div className="absolute bottom-10 ltr:left-8 rtl:right-8 ltr:right-0 rtl:left-0">
        {showwImage ? (
          <img
            src={`${cdnAssetUrl}auth_home.webp`}
            alt="Homes Globe"
            className="relative rtl:-right-8 right-0 top-0 left-0 object-cover"
          />
        ) : null}
        <div className="rtl:py-8 ltr:mr-6 rtl:ml-6">
          <h1 className="w-full xl:w-[240px] font-sans font-medium md:text-[30px] md:leading-[30px] xl:text-[44px] xl:leading-[44px] align-middle tracking-normal text-white mb-4">
            {title}
          </h1>
          <p className="font-light font-sans md:text-[12px] xl:text-[16px] xl:leading-[18px] rtl:leading-8 tracking-normal align-middle  text-white">
            {subTitle1}
          </p>
          <p className="font-light font-sans md:text-[12px] xl:text-[16px] xl:leading-[18px] rtl:leading-8  tracking-normal align-middle  text-white">
            {subTitle2}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BrnadInfoAuth;
